import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from './Button';
import { Card } from './Card';

export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error('Chance & Change crashed', error, info); }
  render() {
    if (this.state.failed) return <main className="center-page"><Card><h1>Something flipped wrong</h1><p>The board hit an unexpected snag.</p><Button onClick={() => location.reload()}>Reload game</Button></Card></main>;
    return this.props.children;
  }
}
